import Axios from 'axios'
import config from '../app.config'

export default {
	getTelephones,
	showTelephone,
	updateTelephone,
	createTelephone,
	deleteTelephone,
	getListTelephone,
	getListTelephoneByAuthFlg,
}
async function getTelephones(payload) {
	return await Axios.get(`${config.LOCAL_API_URL}/telephone-server`, { params: payload })
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
async function showTelephone(id) {
	return await Axios.get(`${config.LOCAL_API_URL}/telephone-server/` + id)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function updateTelephone(data) {
	return await Axios.put(`${config.LOCAL_API_URL}/telephone-server/` + data.id, data)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function deleteTelephone(params) {
	return await Axios.delete(`${config.LOCAL_API_URL}/telephone-server`, { data: params })
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function createTelephone(params) {
	return await Axios.post(`${config.LOCAL_API_URL}/telephone-server`, params)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}

async function getListTelephone(data) {
	return await Axios.get(`${config.LOCAL_API_URL}/getListTelephoneServer`)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}

async function getListTelephoneByAuthFlg(){
	return await Axios.get(`${config.LOCAL_API_URL}/getListTelephoneServerUser`)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
